import { Component, OnInit, ViewChild, ElementRef, OnDestroy, EventEmitter, Output } from "@angular/core";
import { ActivatedRoute, NavigationEnd, Router } from "@angular/router";
import { Subject, Subscription } from "rxjs";
import { filter, takeUntil } from "rxjs/operators";
import { HomeService } from "src/app/feature/user/services/home/home.service";
import { UserService } from "src/app/feature/user/services/user.service";
import { AuthService } from "src/app/shared/services/auth/auth.service";
import { CommonService } from "src/app/shared/services/common/common.service";
import { AppUtil } from "../../utils/utils";
import { Location } from "@angular/common";
import { ProductService } from "src/app/feature/product/services/product.service";
import { SearchService } from "src/app/feature/search/services/search/search.service";
import { TranslateService } from "@ngx-translate/core";
import { DriftEventService } from "src/app/shared/services/drift-service/drift-event.service";
import { Country } from 'src/app/shared/country.type';
import { SharedService } from "src/app/shared/services/shared/shared.service";
import { config } from "src/assets/config/config";
@Component({
selector: "app-header",
templateUrl: "./header.component.html",
styleUrls: ["./header.component.scss"]
})
export class HeaderComponent implements OnInit {
public isUserDropdownOpen = false;
public alertList: Array<any> = [];
private unsubscribe$ = new Subject();
public filteredAlert: Array<any> = [];
@ViewChild('logoutDrift') logoutDrift: ElementRef<HTMLInputElement>;
public showProductUserName = false;
public userDetails: any;
public showAlert = true;
selectedLanguage: { code: string, isoAlpha2Code:string, label: string } = { code: 'sv', isoAlpha2Code: 'se', label: 'Sweden' };
private routerSubscription: Subscription;
languageList:any = [];
region = '';
@Output() languageChanged = new EventEmitter<string>();
@Output() countryChanged = new EventEmitter<string>();
public isAuthenticated = false;
public countryData: any;
public countryId: any;
public page404 = false;
constructor(
  public userService: UserService, 
  public authService: AuthService, 
  public commonService: CommonService, 
  public homeService: HomeService,
  private router: Router,
  private productService: ProductService,
  private searchService: SearchService,
  public translateService: TranslateService,
  private sharedService: SharedService,
  private route: ActivatedRoute,
  public driftEventService: DriftEventService
) {
  
}

onAlertClose() {
  this.showAlert = false;
  this.filteredAlert = [];
}

ngOnInit(): void {
  const country =  (window as any)['country'];  // "norway", "sweden", etc.
  if (country == 'sweden') {
    this.languageList = [
      { code: 'en', isoAlpha2Code: 'se', label: 'Sweden' },
      { code: 'sv', isoAlpha2Code: 'se', label: 'Sweden' }
  ];
  } else if(country == 'norway') {
    this.languageList = [
      { code: 'en', isoAlpha2Code: 'no', label: 'Norway' },
      { code: 'no', isoAlpha2Code: 'no', label: 'Norway' }
    ];
  } else if(country == 'germany') {
    this.languageList = [
      { code: 'en', isoAlpha2Code: 'de', label: 'Germany' },
      { code: 'de', isoAlpha2Code: 'de', label: 'Germany' }
    ];
  } else if(country == 'finland') {
    this.languageList = [
      { code: 'en', isoAlpha2Code: 'fi', label: 'Finland' },
      { code: 'fi', isoAlpha2Code: 'fi', label: 'Finland' }
    ];
  } else if(country == 'denmark') {
    this.languageList = [
      { code: 'en', isoAlpha2Code: 'dk', label: 'Denmark' },
      { code: 'da', isoAlpha2Code: 'dk', label: 'Denmark' }
    ];
  }
  // to remove Login on 404 page
  this.router.events.subscribe(event => {
    if (event instanceof NavigationEnd) {
      const currentUrl = event.urlAfterRedirects;
      this.page404 = (currentUrl == '/404') ? true : false;
    }
  });
  this.countryId = this.commonService.getCountryId();
  this.region = sessionStorage.getItem('region') as string;
  let code = sessionStorage.getItem('country_id') as string;
  this.commonService.language$.subscribe((res) => {
    this.selectedLanguage.isoAlpha2Code = code
  })
  this.countryData = this.commonService.loadCountryData();
  if(this.countryId === 'us'){
    this.getAlertList()
  }
  this.isAuthenticated = false;
  let userType: any = sessionStorage.getItem('userType') ? sessionStorage.getItem('userType') : 'private';
  this.commonService.language$.subscribe(lang => {
      this.getAlertList(lang, userType);
  })
  const savedLang = sessionStorage.getItem("selectedLanguage");
  if(savedLang)
  this.getAlertList(savedLang, userType);
  this.showProductUserName = false;
  // if(!savedLang){
  //   sessionStorage.setItem("selectedLanguage","no-no");
  // }
  this.productService.data$.subscribe((product) => {
    if (product?.customerDetails) {
      this.userDetails = product.customerDetails;
    }
    if (product?.url?.indexOf('/product') > -1) {
      this.showAlert = false;
      this.showProductUserName = true;
    } else if (product === 'backNavigation') {
      this.ngOnInit();
      this.showAlert = true;
    }
  });
  this.searchService.urlData$.subscribe((search) => {
    if (search?.url?.indexOf('/search') > -1) {
      this.showAlert = false;
    } else if (search === 'backNavigation') {
      this.ngOnInit();
      this.showAlert = true;
    }
  });
}

// ngAfterViewInit(): void {
//   // AppUtil.saveToSession('driftDiv', this.myDiv.nativeElement.id);
//   AppUtil.saveToSession('logoutDrift', this.logoutDrift.nativeElement.id);
// }

ngAfterViewInit(): void {
  setTimeout(() => {
      if (this.logoutDrift && this.logoutDrift.nativeElement) {
          AppUtil.saveToSession('logoutDrift', this.logoutDrift.nativeElement.id);
      }
  });
}
public startsWithEn(code: string) {
return code.startsWith('en');
}


/**
 * @description Method to do login action
 */
public doLogin(): void {
  const prevTab = this.commonService.getStringFromSession("previousTab");
  this.userService.doLogin(prevTab);
}

/**
* @description Method to do logout action
*/
public doLogout(): void {
  if (this.authService.isAuthenticated()) {
    localStorage.removeItem(this.countryId+"_tab_details");
    const prevTab = this.commonService.getStringFromSession("previousTab");
    this.authService.doLogout(prevTab);
  }
}

/**
* @description Method to do logout action
*/
public getUserName(): string {
  if (this.showProductUserName) {
    return this.userDetails?.firstName;
  } else {
    const userData = this.userService.getUserData();
    return userData["firstName"];
  }
}

public getAlertList(lang?: string, userType?: string): void {
  this.homeService.getHomeData(lang, userType)
    .pipe(takeUntil(this.unsubscribe$))
    .subscribe((resp) => {
      if (resp) {
        this.alertList = resp?.alertList[0]?.Channel_List;
        for (let i = 0; i < this.alertList?.length; i++) {
          this.filteredAlert = this.alertList.filter(alert => {
            return alert.AlertStatus === 'Active';
          });
        }
      }
    });
}

/**
 * Method to navigate to create user form for sign in
 */
public createUserForm(): void {
  this.homeService.emitData("createUserClick");
  const currentTimeInSeconds = Math.floor(Date.now() / 1000); //unix timestamp in seconds
  let country: Country  = (window as any)['country'] ? (window as any)['country'] as Country : 'us';
  const path = `${config[country]?.region}/home/create-user`;
  this.router.navigate([path], { queryParams: { id: currentTimeInSeconds } });
}



changeSiteLanguage(localeCode: string, isoAlpha2Code: string): void {
  const selectedLanguage = this.languageList.find((language: any) => 
      language.code === localeCode && language.isoAlpha2Code === isoAlpha2Code
  );
  if (selectedLanguage) {
      this.selectedLanguage = selectedLanguage;
      this.translateService.use(`${selectedLanguage.code}-${selectedLanguage.isoAlpha2Code}`);
      this.sharedService.emitLanguageChanged(`${selectedLanguage.code}-${selectedLanguage.isoAlpha2Code}`);
      this.commonService.setLanguage(`${selectedLanguage.code}-${selectedLanguage.isoAlpha2Code}`);
      // const currentUrl = this.router.url.split('?')[0];
      // const baseUrl = currentUrl.replace(/^\/[a-z]{2}-[a-z]{2}/, '');
      // const newLangParam = `${selectedLanguage.code}-${selectedLanguage.isoAlpha2Code.toLowerCase()}`;
      // const newUrl = `/${newLangParam}${baseUrl}`;
      // this.router.navigateByUrl(newUrl);
      this.countryId = sessionStorage.getItem('country_id');
      sessionStorage.setItem('selectedLanguage', `${selectedLanguage.code}-${selectedLanguage.isoAlpha2Code}`);
    }
}

// public productPage(): void {
//   this.router.navigate(["product"], { queryParams: { reason: "Cancel Contract", cust_details: "ddewfwfwefdsvds" } });
// }

public customerClick(): void {
  localStorage.setItem(this.countryId+"_customer", "true");
}
}
